/**
 * custom.js
 *
 * Custom JavaScript (jQuery) code for the Application.
 */

/**
 * Executes the JavaScript code when the DOM is ready to be used.
 * By passing the $ you can code using the $ alias for jQuery.
 * Inside of this function, $() will work as an alias for jQuery()
 * and other libraries also using $ will not be accessible under this shortcut
 */
( function($) {

	// Initialize the Foundation JavaScript
	// Documentation can be found at: http://foundation.zurb.com/docs
	Foundation.Drilldown.defaults.backButton = '<li class="js-drilldown-back"><a>Tilbake</a></li>';
	$(document).foundation();


	// Share buttons pop-up
	$('.social-share-button-popup').click(function(event){
		var el = $(this),
            link = el.attr('href'),
            w = 700,
            h = 400;

		event.preventDefault();
		window.open(link, "Del på Sosiale Medier", 'width=' + w + ', height=' + h);
	});


	// SHOW LOADING GIF
	$(window).load(function() {
		$('.preloader').fadeOut('fast');
	});


	// MOBILE MENU
	$('.site-header .menu-toggle').click(function() {
		$('.site-header ul.menu').slideToggle();
	});

	$(".site-header ul.menu > li.menu-item-has-children > i").click(function(){
		console.log("nivå 1");
		$(this).parent('li').siblings().find(".sub-menu").slideUp("fast");
		$(this).parent('li').siblings().removeClass('open');
		$(this).parent('li').toggleClass('open');
		$(this).parent('li').find('> .sub-menu').slideToggle('fast');
	});
	
	$(".site-header .menu-item-has-children li i").click(function(){
		console.log("nivå 2");
		$(this).parent('li').toggleClass('open').find('.sub-menu').slideToggle('fast');
	});
	

} )(jQuery);
